/* ŽAIDĖJŲ VERTINIMAI — frontend.
   Visi duomenys keliauja į serverį (Worker + D1). Naršyklė nieko nesaugo
   ir neapsimeta saugojanti: sėkmė rodoma tik tada, kai serveris grąžina ok. */
(function () {
  'use strict';

  var PAGE = 16;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += '<i class="rmeta__star' + (i <= n ? ' is-on' : '') + '"></i>';
    return '<span class="rmeta__stars" role="img" aria-label="' + n + ' iš 5 žvaigždučių">' + out + '</span>';
  }

  function ltDate(iso) {
    if (!iso) return '';
    var m = String(iso).match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : String(iso);
  }

  function PlayerReviews(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.prReady === '1') return;
    root.dataset.prReady = '1';

    /* §23 — apsauga nuo dubliuotų listenerių */
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var api = (root.dataset.endpoint || '').replace(/\/+$/, '');
    if (!api) return;

    var form = root.querySelector('[data-pr-form]');
    var listEl = root.querySelector('[data-pr-list]');
    var emptyEl = root.querySelector('[data-pr-empty]');
    var moreEl = root.querySelector('[data-pr-more]');
    var doneEl = root.querySelector('[data-pr-done]');
    var errEl = root.querySelector('[data-pr-error]');
    /* V73 · REVIEWS-002 — sąrašo būsenos, atskiros nuo formos klaidos. */
    var loadEl = root.querySelector('[data-pr-list-loading]');
    var listErrEl = root.querySelector('[data-pr-list-error]');
    var starsErr = root.querySelector('[data-pr-stars-err]');
    var productInputs = root.querySelectorAll('[data-pr-product-option]');

    var fProduct = root.querySelector('[data-pr-filter-product]');
    var fStars = root.querySelector('[data-pr-filter-stars]');
    var fSort = root.querySelector('[data-pr-sort]');

    var offset = 0;
    var titles = {};

    if (productInputs && productInputs.length) {
      [].forEach.call(productInputs, function (input) {
        titles[input.value] = input.dataset.title || input.value;
      });
    }

    /* ?product= — produktas parenkamas automatiškai */
    function preselect() {
      var qp = new URLSearchParams(location.search).get('product');
      if (!qp || !productInputs || !productInputs.length) return;
      var opt = root.querySelector('[data-pr-product-option][value="' + qp + '"]');
      if (opt) opt.checked = true;
    }

    function card(r) {
      return '<li class="prcard">' +
        '<div class="prcard__top">' + stars(r.rating) +
        '<span class="prcard__badge">Žaidėjo vertinimas</span></div>' +
        '<p class="prcard__body">' + esc(r.body) + '</p>' +
        '<p class="prcard__meta"><b>' + esc(r.author) + '</b>' +
        '<span>' + esc(ltDate(r.created_at)) + '</span>' +
        '<span class="prcard__prod">' + esc(titles[r.product] || r.product) + '</span></p>' +
        '</li>';
    }

    function load(append) {
      var q = new URLSearchParams();
      if (fProduct && fProduct.value) q.set('product', fProduct.value);
      if (fStars && fStars.value) q.set('stars', fStars.value);
      if (fSort && fSort.value) q.set('sort', fSort.value);
      q.set('limit', PAGE);
      q.set('offset', append ? offset : 0);

      /* V73 · REVIEWS-002 — `response.ok` patikra.
         Buvo `.then(r => r.json())` be statuso patikros. Jei Worker
         grąžintų 500 su JSON klaidos kūnu, `d.reviews` būtų undefined,
         `(d.reviews || [])` duotų tuščią masyvą, ir vartotojas matytų
         „nėra atsiliepimų" vietoj klaidos. Blogiau: 4xx/5xx atsakymas
         su netikėta struktūra galėtų būti nupieštas kaip validūs
         duomenys. Dabar HTTP klaida krenta į `.catch`, kuris jau rodo
         tuščią būseną. */
      if (loadEl) loadEl.hidden = false;
      if (listErrEl) listErrEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      fetch(api + '/reviews?' + q.toString())
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) {
          if (loadEl) loadEl.hidden = true;
          if (!d || !Array.isArray(d.reviews)) throw new Error('Netinkama struktūra');
          if (!append) { listEl.innerHTML = ''; offset = 0; }
          (d.reviews || []).forEach(function (r) {
            listEl.insertAdjacentHTML('beforeend', card(r));
          });
          offset += (d.reviews || []).length;
          if (emptyEl) emptyEl.hidden = offset > 0;
          if (moreEl) moreEl.hidden = offset >= (d.total || 0);
        })
        .catch(function () {
          /* Klaida NĖRA tas pats, kas „nėra atsiliepimų". Rodome klaidos
             būseną, o tuščią paliekame tik tikram nuliui. */
          if (loadEl) loadEl.hidden = true;
          if (!append && listEl) listEl.innerHTML = '';
          if (listErrEl) listErrEl.hidden = false;
          if (moreEl) moreEl.hidden = true;
        });
    }

    if (fProduct) fProduct.addEventListener('change', function () { load(false); });
    if (fStars) fStars.addEventListener('change', function () { load(false); });
    if (fSort) fSort.addEventListener('change', function () { load(false); });
    if (moreEl) moreEl.addEventListener('click', function () { load(true); });

    /* Uždegamos visos žvaigždutės iki pasirinkto įvertinimo. */
    var starInputs = root.querySelectorAll('.prstar input[name="rating"]');
    function paintStars(value) {
      var n = parseInt(value, 10) || 0;
      [].forEach.call(starInputs, function (input, idx) {
        var label = input.closest('.prstar');
        if (label) label.classList.toggle('is-selected', idx < n);
      });
    }
    function selectedStarValue() {
      var checked = root.querySelector('.prstar input[name="rating"]:checked');
      return checked ? checked.value : 0;
    }
    [].forEach.call(starInputs, function (input) {
      input.addEventListener('change', function () { paintStars(input.value); });
      var label = input.closest('.prstar');
      if (label) {
        label.addEventListener('pointerenter', function () { paintStars(input.value); });
      }
      input.addEventListener('focus', function () { paintStars(input.value); });
    });
    var starsRow = root.querySelector('.prstars__row');
    if (starsRow) {
      starsRow.addEventListener('pointerleave', function () { paintStars(selectedStarValue()); });
      starsRow.addEventListener('focusout', function (e) {
        if (!starsRow.contains(e.relatedTarget)) paintStars(selectedStarValue());
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errEl) errEl.hidden = true;

        var fd = new FormData(form);
        var rating = fd.get('rating');

        /* Be įvertinimo forma nepateikiama. */
        if (!rating) {
          if (starsErr) starsErr.hidden = false;
          var first = form.querySelector('input[name="rating"]');
          if (first) first.focus();
          return;
        }
        if (starsErr) starsErr.hidden = true;

        var payload = {
          product: fd.get('product'),
          rating: parseInt(rating, 10),
          author: fd.get('author'),
          email: fd.get('email'),
          body: fd.get('body'),
          website: fd.get('website') || '',
          consent: !!fd.get('consent'),
          privacy: !!fd.get('privacy')
        };

        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;

        function notifyStore() {
          var nf = root.querySelector('#review-notification');
          var nb = root.querySelector('[data-pr-notify-body]');
          if (!nf || !nb) return;
          nb.value = 'Naujas atsiliepimas\nProduktas: ' + (titles[payload.product] || payload.product)
            + '\nĮvertinimas: ' + payload.rating + '/5'
            + '\nVardas: ' + payload.author
            + '\nEl. paštas: ' + payload.email
            + '\n\n' + payload.body;
          var nfd = new FormData(nf);
          fetch(nf.action || '/contact', { method: 'POST', body: nfd, credentials: 'same-origin' }).catch(function () {});
        }

        fetch(api + '/reviews', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (btn) btn.disabled = false;
            if (!res.ok || !res.j || res.j.ok === false) {
              if (errEl) {
                var code = res.j && res.j.error;
                var fields = (res.j && res.j.fields) || [];
                var message = 'Nepavyko išsaugoti. Bandyk dar kartą.';
                if (code === 'validation') {
                  var names = { product: 'leidimą', rating: 'įvertinimą', author: 'vardą', email: 'el. paštą', body: 'atsiliepimo tekstą', consent: 'sutikimą viešinti', privacy: 'privatumo politikos sutikimą' };
                  var bad = fields.map(function (f) { return names[f] || f; }).join(', ');
                  message = bad ? 'Patikrink šiuos laukus: ' + bad + '.' : 'Patikrink užpildytus laukus.';
                } else if (code === 'duplicate') {
                  message = 'Toks pats atsiliepimas jau buvo pateiktas.';
                } else if (code === 'rate_limited') {
                  message = 'Per trumpą laiką pateikta per daug atsiliepimų. Pabandyk vėliau.';
                } else if (code === 'forbidden') {
                  message = 'Šioje peržiūros aplinkoje atsiliepimo pateikti nepavyko.';
                } else if (code === 'internal_error') {
                  message = 'Serverio klaida. Bandyk dar kartą po kelių minučių.';
                }
                errEl.textContent = message;
                errEl.hidden = false;
              }
              if (window.console && console.warn) console.warn('Review API rejected submission', res.j || {}, 'HTTP ok:', res.ok);
              return;
            }
            /* Sėkmė rodoma TIK po serverio patvirtinimo. */
            form.hidden = true;
            if (doneEl) {
              doneEl.hidden = false;
              var msg = root.querySelector('[data-pr-done-msg]');
              if (msg) msg.textContent = 'Ačiū! Tavo atsiliepimas paskelbtas.';
              var c = root.querySelector('[data-pr-done-card]');
              if (c && res.j.review) c.innerHTML = '<ul class="prcards">' + card(res.j.review) + '</ul>';
              var opt = root.querySelector('[data-pr-product-option][value="' + payload.product + '"]');
              var link = root.querySelector('[data-pr-done-link]');
              if (link && opt && opt.dataset.url) link.href = opt.dataset.url;
              doneEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            /* Naujas vertinimas iškart matomas sąraše ir siunčiamas el. pranešimas. */
            notifyStore();
            load(false);
            /* Ir iškart atnaujiname produkto vidurkį visame puslapyje. */
            if (res.j.rating) applyRating(payload.product, res.j.rating);
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            if (errEl) {
              errEl.textContent = 'Nepavyko susisiekti su atsiliepimų serveriu. Patikrink interneto ryšį ir bandyk dar kartą.';
              errEl.hidden = false;
            }
          });
      });
    }

    preselect();
    load(false);
  }

  /* Bendra funkcija: įrašo serverio reitingą į visus tos prekės rmeta blokus. */
  function applyRating(handle, r) {
    document.querySelectorAll('[data-rating-for="' + handle + '"]').forEach(function (el) {
      var avg = el.querySelector('[data-rating-avg]');
      var cnt = el.querySelector('[data-rating-count]');
      if (avg && r.average != null) avg.textContent = String(r.average).replace('.', ',') + '/5';
      if (cnt && r.count != null) cnt.textContent = r.count;
      var empty = el.querySelector('[data-rating-empty]');
      if (empty && r.average != null) empty.hidden = true;
    });
  }

  /* Puslapiuose, kur yra reitingų, pasiimame gyvą suvestinę iš serverio. */
  function syncRatings() {
    var host = document.querySelector('[data-ratings-api]');
    if (!host) return;
    var api = (host.dataset.ratingsApi || '').replace(/\/+$/, '');
    if (!api) return;
    /* V73 · REVIEWS-002 — `response.ok` patikra.
       Be jos HTTP 500 su JSON kūnu būtų perduotas `Object.keys()`, ir
       klaidos objekto raktai virstų „reitingais" ant produktų kortelių.
       Tai būtų tyliai klaidinantys duomenys pirkėjui. */
    fetch(api + '/ratings')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        if (!d || typeof d !== 'object') return;
        Object.keys(d).forEach(function (h) { applyRating(h, d[h]); });
      })
      .catch(function () { /* tyliai: rodomos metafieldų reikšmės */ });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-player-reviews]').forEach(PlayerReviews);
    syncRatings();
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();
